const LayerValue = {
    content: 1,
    alpha: 500,
    epsilon: 600,
    iota: 700,
    omicron: 800,
    tau: 900,
};

export { LayerValue };
//# sourceMappingURL=types.js.map
